import ArticleCardSkeleton from "../../articles/components/ArticleCardSkeleton";
import { ARTICLE_CARD_GRID_CLASS } from "./articleGridClass";

export function ArticleTabSkeleton() {
  return (
    <div className={ARTICLE_CARD_GRID_CLASS}>
      {Array.from({ length: 6 }).map((_, i) => (
        <ArticleCardSkeleton key={i} />
      ))}
    </div>
  );
}
